(function () {

  'use strict';

  function pxDestinationConnector(RegexModel) {
    return {
      restrict: 'E',
      scope: {
        me: '=',
        tenant: '=',
        workflowForm: '=',
        workflowFormModel: '=',
        fileNameShorthands: '=',
        fileNameFormModel: '='
      },
      templateUrl: 'app/components/settings/workflows/workflowProperties/destination/connector/destinationConnector.template.html',
      link: function (scope, element, attrs) {

        scope.BAD_FILE_NAME = new RegexModel().badNameString_variables().string;

        scope.hasValidationError = function (model, attr) {
          return scope.workflowFormModel.errors[model + '.' + attr];
        };

        scope.validateNumericValueOnModel = function (model, attr, minValue, maxValue) {
          const valueAsNumber = Number(scope.workflowFormModel[model][attr]);
          const valueIsInvalid = !valueAsNumber || valueAsNumber < minValue || valueAsNumber > maxValue;
          if (valueIsInvalid) {
            scope.workflowForm.$invalid = true;
          }
          scope.workflowFormModel.errors[model + '.' + attr] = valueIsInvalid;
        };

      }
    };
  }

  pxDestinationConnector.$inject = ['RegexModel'];

  angular
    .module('printix-admin')
    .directive('pxDestinationConnector', pxDestinationConnector);

})();
